<template scope='scope'>
<div>
        <div class="header">
            <el-menu class="menu"  mode="horizontal" @select="onMenuClck" >
                <el-menu-item index="Home">Home</el-menu-item>
                <el-menu-item index="Design">Design</el-menu-item>
                <el-menu-item index="Analysis">Analysis</el-menu-item>
                <el-menu-item index="Download">Download</el-menu-item>
                <el-menu-item index="FAQ">FAQ</el-menu-item>
                <el-menu-item index="Contact">Contact</el-menu-item>
                <el-menu-item index="MyProject">MyProject</el-menu-item>
                <el-menu-item index="Login" class="login">
                  <i class="el-icon-s-custom"></i> {{!token ? 'Login' :'Logout'}}
                </el-menu-item>
                <img src="../assets/logo1.png" alt="">
            </el-menu>
        </div>
        <div class="main">
            <slot/>
        </div>
        <div class="footer">
            <div class="footer-content">
                <h2>Address<br/></h2>
                <p>
                    Food & Enviromental Microbiology Lab, SJTU,<br/>
                    800 Dongchuan Road, Minhang, Shanghai 200240, China.<br/>
                </p>
            </div>
            <div style="marginLeft:30px" class="footer-content">
                <h2>Copyright<br/></h2>
                <p >
                    Copyright 2013-2024, Shanghai Jiao Tong University<br/>
                    沪交ICP备20220151<br/>
                </p>
            </div>

        </div>
</div>
</template>
<script>
export default {
    computed:{
        token(){
            return this.$store.state.token
        }
    },
    methods:{
        onMenuClck(value){
            
            if (value == 'Login') {
                this.$store.commit('UpdateState',{token:'',userId:''})
                localStorage.clear()
            }
            this.$router.push('/'+value)
            
        }
    }
}
</script>

<style lang="scss" scoped>
.header{
    background: #0C3C60;
    position: relative;
    display: flex;
    justify-content: center;
    .menu{
        padding-top: 65px;
        background: #0C3C60;
        position: relative;
        border-bottom: none;
        .el-menu-item{
            color: #fff;
            border-bottom: 0px;
            font-size: 16px;
            height: 30px;
            line-height: 25px;
        }
        .el-menu--horizontal>.el-menu-item:hover{
            border-bottom: 0px;
        }
        .login{
            position: absolute;
            top: 10px;
            right: 0px;
            color: rgb(30, 171, 199);
        }
        img{
            width: 80px;
            position: absolute;
            z-index: 1;
            left: -80px;
            top: 6px;
        }
    }
}
.main{
    padding: 40px 0;
    min-height: 500px;
}
.footer{
    background: #0C3C60;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10%;
    a{
        color: #fff;
        text-decoration:none;
    }
    .footer-content{
        text-align: left;
    }
}
.footer-after{
    height: 100px;
    background: #0C3C60;
}
</style>




// WEBPACK FOOTER //
// src/components/Layout.vue